import { render, staticRenderFns } from "./EhrIndexPage.vue?vue&type=template&id=2623741f"
import script from "./EhrIndexPage.vue?vue&type=script&lang=js"
export * from "./EhrIndexPage.vue?vue&type=script&lang=js"
import style0 from "./EhrIndexPage.vue?vue&type=style&index=0&id=2623741f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports